module.exports = __webpack_public_path__ + "img/E41.915e8f55.png";